import React, { useState } from "react";
import "./Adicionar.css";
import {
  FaClipboardList,
  FaUsers,
  FaCommentDots,
  FaPaperPlane,
  FaCheckCircle,
} from "react-icons/fa";
import PrivateMenuCampanha from "../../privateMenuCampanha";
import PrivateMenuLeft from "../../../../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../../../../sections/Header/privateMenuUp";
import CampaignListOperations from "./CampaignListOperations";
import Operacoes from "./Operacoes";
import GruposOperation from "./GruposOperation";
import ChangeGroupNameComponent from "./operations/ChangeGroupName";
import SendMessageGroup from "./operations/SendMessageGroup";
import RevisionPanel from "./operations/RevisionPanel";
import useAuth from "../../../../../../components/hooks/useAuth";
import { useNavigate, useParams } from "react-router-dom";
import ChangeGroupDescription from "./operations/ChangeGroupDescription";
import ChangeGroupPicture from "./operations/ChangeGroupPicture";
import ChangeGroupSettings from "./operations/ChangeGroupSettings";

const STEPS = [
  { code: "operation", label: "Operação", icon: <FaClipboardList /> },
  { code: "campaign", label: "Campanha", icon: <FaCheckCircle /> },
  { code: "groups", label: "Grupos", icon: <FaUsers /> },
  { code: "content", label: "Conteúdo", icon: <FaCommentDots /> },
  { code: "review", label: "Revisão", icon: <FaPaperPlane /> },
];

const INTERNAL_TO_BACKEND_TYPE_MAP = {
  ChangeGroupName: "edit_group_name",
  SendMessageGroup: "send_message",
  ChangeGroupDescription: "edit_group_description",
  ChangeGroupPicture: "edit_group_picture",
  ChangeGroupSettings: "edit_group_settings",
};

const CampaignAddOperations = () => {
  const { postApi } = useAuth();
  const [currentStep, setCurrentStep] = useState("operation");
  const [operationType, setOperationType] = useState("");
  const [selectedCampaignIds, setSelectedCampaignIds] = useState([]);
  const [selectedGroupIds, setSelectedGroupIds] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  // ESTADO GLOBAL (ENGLISH)
  const [messages, setMessages] = useState([]);
  const [mentionAll, setMentionAll] = useState(false);
  const [ephemeralExpiration, setEphemeralExpiration] = useState("off");
  const [sendingSpeed, setSendingSpeed] = useState("normal");
  const [schedulingType, setSchedulingType] = useState("now");
  const [scheduledAt, setScheduledAt] = useState("");

  const [newGroupName, setNewGroupName] = useState("");
  const { id: campaignId } = useParams();
  const [newGroupDescription, setNewGroupDescription] = useState(""); // Novo estado
  const [newGroupPicture, setNewGroupPicture] = useState(null); // Novo estado

  // Estados para ChangeGroupSettings
  const [restrictAnnouncement, setRestrictAnnouncement] = useState(false);
  const [maxMembers, setMaxMembers] = useState(1024);
  const [ephemeralHours, setEphemeralHours] = useState(0);

  const primaryColor = window.notifyColor || "#005c53";
  const navigate = useNavigate(); // NOVO: hook para navegação


  const handleCreateOperation = async () => {
    setIsProcessing(true);
    try {
      const type = INTERNAL_TO_BACKEND_TYPE_MAP[operationType] || operationType;

      let config = {};
      if (operationType === "ChangeGroupName") {
        let config = { new_name: newGroupName };
        return handleBulkEditGroupConfig(config);
      } else if (operationType === "ChangeGroupDescription") {
        let config = { new_description: newGroupDescription };
        return handleBulkEditGroupConfig(config);
      } else if (operationType === "ChangeGroupPicture") {
        config = { new_picture: newGroupPicture };
        return handleBulkEditGroupConfig(config);
      } else if (operationType === "ChangeGroupSettings") {
        config = {
          restrict_announcement: restrictAnnouncement ? "announcement" : "not_announcement",
          max_members: maxMembers,
          ephemeral_expiration: ephemeralHours
        };

        return handleBulkEditGroupConfig(config);
      }
      else if (operationType === "SendMessageGroup") {

        config = {
          messages,
          mention_all: mentionAll,
          ephemeral: ephemeralExpiration,
          speed: sendingSpeed,
        };

        return handleBulkSendMessageGroup(config);
      }
    } catch (error) {
      console.error("Critical Failure:", error);
      alert("Erro ao criar operação.");
    } finally {
    }
  };




  const handleBulkSendMessageGroup = async (config) => {
    setIsProcessing(true);

    console.log(selectedGroupIds)
    console.log(config);
    const payload = {
      campaign_ids: selectedCampaignIds,
      group_ids: selectedGroupIds,
      config,
      scheduled_at: schedulingType === "scheduled" ? scheduledAt : null,
    };

    const response = await postApi("/api/v1/linkedzap/bulk/sendmessage/group", payload);

    setIsProcessing(false);
    if (response) {
      alert(schedulingType === "scheduled" ? "Operação agendada com sucesso!" : "Operação enviada com sucesso!");

      setCurrentStep("operation");
      setSelectedCampaignIds([]);
      setSelectedGroupIds([]);
      setMessages([]);
      setOperationType("");

      if (campaignId) {
        navigate(`/campanha/${campaignId}/operacoes`)
      }
    }

  }

  const handleBulkEditGroupConfig = async (config) => {
    setIsProcessing(true);

    const payload = {
      campaign_ids: selectedCampaignIds,
      group_ids: selectedGroupIds,
      config,
      scheduled_at: scheduledAt,
    };

    try {

      const response = await postApi("/api/v1/campaign/groups/bulkupdate/config", payload);
      if (response) {
        alert(schedulingType === "scheduled" ? "Operação agendada com sucesso!" : "Operação enviada com sucesso!");

        setCurrentStep("operation");
        setSelectedCampaignIds([]);
        setSelectedGroupIds([]);
        setMessages([]);
        setOperationType("");

        if (campaignId) {
          navigate(`/campanha/${campaignId}/operacoes`)
        }


      }
    } catch (error) {
      console.error("Critical Failure:", error);
      alert("Erro ao criar operação.");
    } finally {
    }

  }

  const getNextStep = (code) => {
    const idx = STEPS.findIndex((s) => s.code === code);
    return idx !== -1 && idx < STEPS.length - 1 ? STEPS[idx + 1].code : code;
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", backgroundColor: "#f0f2f5" }}>
      <PrivateMenuLeft />
      <PrivateMenuUp />
      <div style={{ marginLeft: window.innerWidth <= 768 ? 56 : 70, width: "100%", display: "flex", flexDirection: "column" }}>
        <PrivateMenuCampanha />
        <nav style={{ width: "100%", height: 60, background: "linear-gradient(90deg, #005c53 0%, #008f7a 100%)", color: "#fff", display: "flex", alignItems: "center", padding: "0 24px", position: "fixed", top: 0, zIndex: 2000 }}>
          <span style={{ fontWeight: "600", fontSize: 20 }}>Operações LinkedZap</span>
        </nav>
        <div style={{ flex: 1, padding: "40px 24px", marginTop: 60 }}>

          {/* STEPPER NAVEGÁVEL */}
          <div style={{ display: "flex", justifyContent: "center", gap: 12, marginBottom: 40, background: "#fff", padding: "20px", borderRadius: "16px" }}>
            {STEPS.map((step, idx) => {
              const isActive = currentStep === step.code;
              const isPast = STEPS.findIndex(s => s.code === currentStep) > idx;
              return (
                <React.Fragment key={step.code}>
                  <div
                    style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8, opacity: isActive || isPast ? 1 : 0.4, cursor: "pointer" }}
                    onClick={() => setCurrentStep(step.code)}
                  >
                    <div style={{ width: 40, height: 40, borderRadius: "12px", background: isActive ? primaryColor : isPast ? "#005c53" : "#e0e0e0", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      {isPast ? <FaCheckCircle size={18} /> : step.icon}
                    </div>
                    <span style={{ fontSize: 11, fontWeight: "600", color: isActive ? primaryColor : "#666" }}>{step.label}</span>
                  </div>
                  {idx < STEPS.length - 1 && <div style={{ height: 2, width: 30, background: isPast ? "#005c53" : "#e0e0e0", marginTop: 20 }} />}
                </React.Fragment>
              );
            })}
          </div>

          <div style={{ background: "#fff", borderRadius: "20px", padding: "30px", minHeight: "500px", boxShadow: "0 4px 20px rgba(0,0,0,0.05)" }}>
            {currentStep === "operation" && (
              <Operacoes
                selected={operationType}
                setSelected={setOperationType}
                setEtapaAtual={setCurrentStep}
                setOperacaoSelecionada={setOperationType}
              />
            )}

            {currentStep === "campaign" && <CampaignListOperations campaignSelected={selectedCampaignIds} setCampaignSelected={setSelectedCampaignIds} setEtapaAtual={setCurrentStep} nextStep={getNextStep("campaign")} />}
            {currentStep === "groups" && <GruposOperation campaignIds={selectedCampaignIds} gruposSelecionados={selectedGroupIds} setGruposSelecionados={setSelectedGroupIds} setEtapaAtual={setCurrentStep} nextStep={getNextStep("groups")} />}

            {currentStep === "content" && (
              <>
                {operationType === "ChangeGroupName" && (
                  <ChangeGroupNameComponent
                    novoNomeGrupo={newGroupName} setNovoNomeGrupo={setNewGroupName}
                    tipoAgendamento={schedulingType} setTipoAgendamento={setSchedulingType}
                    dataAgendamento={scheduledAt} setDataAgendamento={setScheduledAt}
                    setEtapaAtual={setCurrentStep} nextStep={getNextStep("content")}
                  />
                )}
                {operationType === "ChangeGroupDescription" && (
                  <ChangeGroupDescription
                    newGroupDescription={newGroupDescription} setNewGroupDescription={setNewGroupDescription}
                    schedulingType={schedulingType} setSchedulingType={setSchedulingType}
                    scheduledAt={scheduledAt} setScheduledAt={setScheduledAt}
                    setEtapaAtual={setCurrentStep} nextStep={getNextStep("content")}
                  />
                )}
                {operationType === "ChangeGroupPicture" && (
                  <ChangeGroupPicture
                    newGroupPicture={newGroupPicture} setNewGroupPicture={setNewGroupPicture}
                    schedulingType={schedulingType} setSchedulingType={setSchedulingType}
                    scheduledAt={scheduledAt} setScheduledAt={setScheduledAt}
                    setEtapaAtual={setCurrentStep} nextStep={getNextStep("content")}


                  />
                )}

                {operationType === "ChangeGroupSettings" && (
                  <ChangeGroupSettings
                    restrictAnnouncement={restrictAnnouncement} setRestrictAnnouncement={setRestrictAnnouncement}
                    maxMembers={maxMembers} setMaxMembers={setMaxMembers}
                    ephemeralHours={ephemeralHours} setEphemeralHours={setEphemeralHours}
                    schedulingType={schedulingType} setSchedulingType={setSchedulingType}
                    scheduledAt={scheduledAt} setScheduledAt={setScheduledAt}
                    setEtapaAtual={setCurrentStep} nextStep={getNextStep("content")}
                  />
                )}


                {operationType === "SendMessageGroup" && (
                  <SendMessageGroup
                    messages={messages} setMessages={setMessages}
                    mentionAll={mentionAll} setMentionAll={setMentionAll}
                    ephemeralExpiration={ephemeralExpiration} setEphemeralExpiration={setEphemeralExpiration}
                    sendingSpeed={sendingSpeed} setSendingSpeed={setSendingSpeed}
                    schedulingType={schedulingType} setSchedulingType={setSchedulingType}
                    scheduledAt={scheduledAt} setScheduledAt={setScheduledAt}
                    setEtapaAtual={setCurrentStep} nextStep={getNextStep("content")}
                  />
                )}
              </>
            )}

            {currentStep === "review" && (
              <RevisionPanel
                operationType={operationType}
                newGroupName={newGroupName}
                messages={messages}
                mentionAll={mentionAll}
                ephemeralExpiration={ephemeralExpiration}
                sendingSpeed={sendingSpeed}
                campaignSelected={selectedCampaignIds}
                gruposSelecionados={selectedGroupIds}
                schedulingType={schedulingType}
                scheduledAt={scheduledAt}
                setEtapaAtual={setCurrentStep}
                primaryColor={primaryColor}
                handleConfirm={handleCreateOperation}
                isProcessing={isProcessing}
                newGroupDescription={newGroupDescription}
                newGroupPicture={newGroupPicture}

                restrictAnnouncement={restrictAnnouncement}
                maxMembers={maxMembers}
                ephemeralHours={ephemeralHours}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignAddOperations;